import styled from "styled-components";

export const AppTabsMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ul {
    position: relative;
    display: flex;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: #C96262;
    }
  }
`

interface MenuItemProps {
  isSelected?: boolean;
  text: string;
}

export const MenuItem = styled.li<MenuItemProps>`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem 1rem;
  cursor: pointer;
  
  font: 1rem/1.1rem "Roboto", sans-serif;
  color: ${({ theme }: {theme: any}) => theme.themeDarker};
  font-weight: ${({ isSelected }) => isSelected ? '700' : '300'};
  opacity: ${({ isSelected }) => isSelected ? '1' : '.7'};
  transition: color 0.3s ease-out;
  
  &:hover {
    opacity: 1;
  }

  &::before {
    content: "${({ text }) => text}";
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    height: 0;
    font-weight: 700;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    width: ${({ isSelected }) => isSelected ? 'calc(100% + 0.5rem)' : '0'};
    height: 7px;
    background: ${({theme}) => theme.themePrimary};
    border-radius: 0.5rem;
    z-index: 1;
    transition: all 0.3s ease-out;
  }
`